var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","dark":"","clipped-left":""}},[_c('v-toolbar-title',[_vm._v("OLV Admin")]),_c('v-spacer'),_c('AppBarUserMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }